import { MatDialogRef } from '@angular/material/dialog';
import { of, timer } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { filter, map, switchMap, take, tap, takeUntil } from 'rxjs/operators';

import { AuthService, TokenService } from 'src/app/_shared/services';
import { InitActions } from 'src/app/_store/_init/actions';
import { AutoLogoutComponent } from 'src/app/auto-logout/auto-logout.component';
import { AppActions } from 'src/app/_store/_actions';

@Injectable()
export class AuthEffects {
  checkAuth$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(InitActions.init.type),
        tap(() => {
          return timer(1000, 2000)
            .pipe(
              switchMap(() => this.auth.authed.pipe(take(1))),
              switchMap((payload) => {
                // if we have a payload we're still authed, but only show expiration it we also have a token hash (previously-authed)
                return of(payload ? false : !!this.token.hash);
              }),
              map((expired) => {
                if (expired) return 1;

                return 0;
              }),
              filter(() => {
                // don't keep emitting if there's an activeDialog that isn't the warning (which can expire)
                return (
                  !this.activeDialog ||
                  (this.activeDialog &&
                    this.activeDialog.componentInstance &&
                    this.activeDialog.componentInstance.data.warn)
                );
              }),
              takeUntil(this.actions$.pipe(ofType(AppActions.logout)))
            )
            .subscribe((expired) => {
              // session expired
              if (expired === 1) {
                // warning dialog still open; close it
                if (this.activeDialog) {
                  this.activeDialog.close();
                }
                this.token.expire();
              }
            });
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions<InitActions.InitActionsUnion>,
    private auth: AuthService,
    private token: TokenService
  ) {}

  private activeDialog: MatDialogRef<AutoLogoutComponent>;
}
